import React, { useState } from "react";
import "../static/css/AdminTeam.css";

function PublicationPage() {
  const [name, setName] = useState("");
  const [role, setrole] = useState("");
  const [short_description, setshort_description] = useState("");
  const [description, setdescription] = useState("");
  const [image, setImage] = useState(null);
  const [specializations, setSpecializations] = useState([""]);

  const addSpecialization = () => {
    setSpecializations([...specializations, ""]);
  };

  const handleSpecializationChange = (index, value) => {
    const updatedSpecializations = [...specializations];
    updatedSpecializations[index] = value;
    setSpecializations(updatedSpecializations);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("role", role);
    formData.append("short_description", short_description);
    formData.append("description", description);
    formData.append("image", image);
    formData.append("specializations", JSON.stringify(specializations));

    try {
      const response = await fetch("https://skpbackend.quindl.com/team/add", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        alert("Team member added successfully!");
        console.log(result);
      } else {
        const errorText = await response.text();
        console.error("Error response:", errorText);
        alert("Failed to add team member: " + errorText);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting form.");
    }
  };

  return (
    <>
      <div className="team-page">
        <div className="admin-team">
          <div className="admin-team__container">
            <form className="admin-team__form">
              <div className="admin-team__form-group">
                <label htmlFor="name">Team Member Name</label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="role">Role</label>
                <input
                  id="role"
                  type="text"
                  value={role}
                  onChange={(e) => setrole(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="short_description">short_description</label>
                <input
                  id="short_description"
                  type="text"
                  value={short_description}
                  onChange={(e) => setshort_description(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="description">description</label>
                <input
                  id="description"
                  type="text"
                  value={description}
                  onChange={(e) => setdescription(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label>Specialization</label>
                {specializations.map((specialization, index) => (
                  <input
                    key={index}
                    type="text"
                    value={specialization}
                    onChange={(e) =>
                      handleSpecializationChange(index, e.target.value)
                    }
                    placeholder={`Specialization ${index + 1}`}
                    className="admin-team__input"
                  />
                ))}
                <button
                  type="button"
                  onClick={addSpecialization}
                  className="admin-team__add-btn"
                >
                  Add Another Specialization
                </button>
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="TeamMember">Team Member Image</label>
                <div className="admin-team__file-upload">
                  <input
                    type="file"
                    id="thumbnail"
                    onChange={(e) => setImage(e.target.files[0])}
                    className="admin-team__file-input"
                  />
                  <span className="admin-team__upload-placeholder">
                    <i
                      className="admin-team__upload-icon"
                      id="image"
                      value={image}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM2.66667 21.3333H21.3333V2.66667H2.66667V21.3333ZM4 18.6667H20L15 12L11 17.3333L8 13.3333L4 18.6667Z"
                          fill="#828282"
                        />
                      </svg>
                    </i>
                    Upload Image
                  </span>
                </div>
              </div>
              <button className="admin-team__submit-btn" onClick={handleSubmit}>
                Update
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
export default PublicationPage;
